const Camera = (props) => (
  <svg
    {...props}
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0001 14.091C19.0001 14.5249 18.8277 14.9412 18.5208 15.248C18.2139 15.5549 17.7977 15.7273 17.3637 15.7273H2.63637C2.20238 15.7273 1.78616 15.5549 1.47928 15.248C1.1724 14.9412 1 14.5249 1 14.091V5.09092C1 4.65693 1.1724 4.24071 1.47928 3.93383C1.78616 3.62696 2.20238 3.45455 2.63637 3.45455H5.90911L7.54547 1H12.4546L14.0909 3.45455H17.3637C17.7977 3.45455 18.2139 3.62696 18.5208 3.93383C18.8277 4.24071 19.0001 4.65693 19.0001 5.09092V14.091Z"
      stroke="white"
      strokeWidth="1.63637"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0001 12.4547C11.8076 12.4547 13.2728 10.9894 13.2728 9.18192C13.2728 7.37443 11.8076 5.90918 10.0001 5.90918C8.19261 5.90918 6.72736 7.37443 6.72736 9.18192C6.72736 10.9894 8.19261 12.4547 10.0001 12.4547Z"
      stroke="white"
      strokeWidth="1.63637"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Camera
